import { axiosInstance } from '@/modules/shared/lib/axios';
import { UserMutationResponse, UserMutationPayload } from './types';

type Props = {
  companyId: string
  payload: UserMutationPayload
}

export function createAdminUser ({ companyId, payload }: Props) {
    return axiosInstance.post<UserMutationResponse>(`/config-api/${companyId}/configuration/admin/users`, payload);
}
